__turbopack_context__.v({
  "bodyText": "DealsBanner-module-scss-module__IK_8Wq__bodyText",
  "ctaWrap": "DealsBanner-module-scss-module__IK_8Wq__ctaWrap",
  "dealsClearance": "DealsBanner-module-scss-module__IK_8Wq__dealsClearance",
  "descriptionRow": "DealsBanner-module-scss-module__IK_8Wq__descriptionRow",
  "membershipDiscount": "DealsBanner-module-scss-module__IK_8Wq__membershipDiscount",
  "promos": "DealsBanner-module-scss-module__IK_8Wq__promos",
  "root": "DealsBanner-module-scss-module__IK_8Wq__root",
  "title": "DealsBanner-module-scss-module__IK_8Wq__title",
  "titleRow": "DealsBanner-module-scss-module__IK_8Wq__titleRow",
  "titleTooltip": "DealsBanner-module-scss-module__IK_8Wq__titleTooltip",
  "tooltipInline": "DealsBanner-module-scss-module__IK_8Wq__tooltipInline",
  "tooltipTrigger": "DealsBanner-module-scss-module__IK_8Wq__tooltipTrigger",
});
